module.exports = __webpack_public_path__ + "static/media/n_icon_arrow_gray@2x.bf7198bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_arrow_gray@2x.png
// module id = 272
// module chunks = 0 1